<template>
  <div>
    <div class="d-flex justify-content-between">
      <h1 class="page-header">{{ $t('paymentTesting.pageTitle') }}</h1>
      <ts-breadcrumb
        :items="[
          { text: $t('toHomePage'), href: '/' },
          { text: $t('paymentTesting.pageTitle'), href: '/payment-testing' },
          {
            text: $t('edit'),
            active: true
          }
        ]"
      />
    </div>
    <ts-card>
      <ts-card-wrapper>
        <ts-loading-banner :loading="loading">
          <div class="row">
            <div class="col-md-6">
              <form>
                <fieldset>
                  <legend>{{ $t('paymentTesting.studentInquiry') }}</legend>
                  <inquery-search v-model="model" />
                </fieldset>
              </form>
            </div>
            <div class="col-md-6">
              <form class="form-horizontal">
                <fieldset>
                  <legend>{{ $t('paymentTesting.paymentInfo') }}</legend>
                  <div class="row form-group">
                    <label class="required col-md-4 col-form-label">{{
                      $t('paymentTesting.date')
                    }}</label>
                    <div class="col-md-8">
                      <a-date-picker
                        v-model="model.payment_date"
                        format="DD-MM-YYYY"
                        style="width:100%"
                      ></a-date-picker>
                      <div class="validate" v-if="errors.has('payment_date')">
                        {{ errors.first('payment_date') }}
                      </div>
                    </div>
                  </div>
                  <div class="row form-group">
                    <label class="required col-md-4 col-form-label">{{
                      $t('paymentTesting.student')
                    }}</label>
                    <div class="col-md-8">
                      <input
                        v-model="model.student_name"
                        type="text"
                        class="form-control"
                        readonly
                      />
                      <div class="validate" v-if="errors.has('inquiry_id')">
                        {{ errors.first('inquiry_id') }}
                      </div>
                    </div>
                  </div>
                  <div class="row form-group">
                    <label class="required col-md-4 col-form-label">{{
                      $t('paymentTesting.subProgram')
                    }}</label>
                    <div class="col-md-8">
                      <a-select
                        v-model.number="model.acps_id"
                        show-search
                        optionFilterProp="children"
                        :default-active-first-option="false"
                        :filterOption="
                          (input, option) =>
                            option.componentOptions.children[0].text
                              .toLowerCase()
                              .indexOf(input.toLowerCase()) >= 0
                        "
                        :options="subProgramList"
                        @change="onSubProgramChange"
                      ></a-select>
                      <div class="validate" v-if="errors.has('acps_id')">
                        {{ errors.first('acps_id') }}
                      </div>
                    </div>
                  </div>
                  <div class="row form-group">
                    <label class="required col-md-4 col-form-label">{{
                      $t('paymentTesting.academicTerm')
                    }}</label>
                    <div class="col-md-8">
                      <a-select
                        v-model.number="model.ac_term_id"
                        :loading="fetch_ac_term"
                        :options="ac_term_lists"
                        @change="handleActermchange"
                      ></a-select>
                      <div class="validate" v-if="errors.has('ac_term_id')">
                        {{ errors.first('ac_term_id') }}
                      </div>
                    </div>
                  </div>
                  <div class="row form-group">
                    <label class="required col-md-4 col-form-label">{{
                      $t('paymentTesting.amount')
                    }}</label>
                    <div class="col-md-8">
                      <input
                        v-model.number="model.payment_amount"
                        type="number"
                        step="any"
                        class="form-control"
                      />
                      <div class="validate" v-if="errors.has('payment_amount')">
                        {{ errors.first('payment_amount') }}
                      </div>
                    </div>
                  </div>
                </fieldset>
              </form>
            </div>
          </div>
          <div class="row mt-3">
            <div class="col-md-12">
              <panel :title="$t('paymentTesting.item')">
                <item-details v-model="model" :validate="errors" />
                <div class="row mt-3">
                  <div class="col-md-12 text-right">
                    <ts-button
                      class="mr-2"
                      @click="$router.push({ name: 'payment-test' })"
                      >{{ $t('cancel') }}</ts-button
                    >
                    <ts-button
                      color="primary"
                      :waiting="waiting"
                      @click.prevent="onUpdate"
                      >{{ $t('update') }}</ts-button
                    >
                  </div>
                </div>
              </panel>
              <div class="validate" v-if="errors.has('fee_detail_list')">
                {{ errors.first('fee_detail_list') }}
              </div>
            </div>
          </div>
        </ts-loading-banner>
      </ts-card-wrapper>
    </ts-card>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import { Errors } from 'form-backend-validation'
import moment from 'moment'
import InquerySearch from './components/inquire_search'
import ItemDetails from './components/item-details'

export default {
  name: 'editPaymentTesting',
  components: {
    InquerySearch,
    ItemDetails
  },
  data() {
    return {
      errors: new Errors(),
      loading: false,
      fetch_ac_term: false,
      waiting: false,
      ac_term_lists: [],
      model: {
        payment_id: 0,
        payment_date: moment(),
        inquiry_id: null,
        student_name: null,
        ac_year_id: null,
        ac_term_id: null,
        acps_id: null,
        payment_amount: null,
        fee_detail_list: []
      }
    }
  },
  computed: {
    ...mapState('paymentTesting', ['edit_data']),
    subProgramList() {
      return this.$store.state.paymentTesting.subPrograms.map(el => ({
        value: el.acps_id,
        label: el.acps_name_foreign
      }))
    }
  },
  created() {
    this.loading = true
    this.fetchBeforeCreate()
    this.setEditData()
  },
  methods: {
    ...mapActions('paymentTesting', [
      'getFeeSetup',
      'getSubProgram',
      'getTermBySub',
      'update'
    ]),
    onUpdate() {
      this.errors = new Errors()
      this.waiting = true
      this.update({
        id: this.model.payment_id,
        data: this.model
      })
        .then(response => {
          this.$toasted.success(response.message)
          this.$router.push({ name: 'payment-test' })
        })
        .catch(error => {
          this.errors = new Errors(error.errors)
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.waiting = false
        })
    },
    async fetchBeforeCreate() {
      await this.getFeeSetup()
      await this.getSubProgram()
      this.loading = false
    },
    onSubProgramChange(acpsId) {
      this.model.ac_term_id = null
      this.model.ac_year_id = null
      this.ac_term_lists = []
      this.getTerm()
    },
    getTerm(acpsId) {
      this.fetch_ac_term = true
      this.getTermBySub(acpsId)
        .then(response => {
          this.ac_term_lists = response.data.map(el => ({
            value: el.ac_term_id,
            label: el.term_name,
            ac_year_id: el.ac_year_id
          }))
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.fetch_ac_term = false
        })
    },
    handleActermchange(acTermId) {
      this.model.ac_year_id = this.ac_term_lists
        .filter(ac => ac.value == acTermId)
        .reduce((init, item) => (init = item.ac_year_id), null)
    },
    setEditData() {
      if (!_.isEmpty(this.edit_data)) {
        this.model.payment_id = this.edit_data.payment_id
        this.model.payment_date = moment(
          this.edit_data.payment_date,
          'DD-MM-YYYY'
        )
        this.model.inquiry_id = this.edit_data.inquiry_id
        this.model.student_name = this.edit_data.inquiry.full_name_en
        this.model.ac_year_id = this.edit_data.ac_year_id
        this.model.ac_term_id = this.edit_data.ac_term_id
        this.model.acps_id = this.edit_data.acps_id
        this.model.payment_amount = this.edit_data.payment_amount
        this.getTerm(this.edit_data.acps_id)
        this.edit_data.details.forEach(el => {
          this.model.fee_detail_list.push({
            fee_setup_id: el.fee_setup_id,
            fee_description: el.fee_description,
            fee_amount: el.fee_amount,
            discount_type: el.discount_type,
            discount_rate: el.discount_rate,
            discount_amount: el.discount_amount,
            discount_reason: el.discount_reason,
            total_amount: el.total_amount,
            vat_rate: el.vat_rate,
            vat_amount: el.vat_amount,
            amount_include_vat: el.amount_include_vat
          })
        })
      }
    }
  },
  beforeRouteLeave(to, from, next) {
    this.$store.commit('paymentTesting/SET_EDIT_DATA', [])
    next()
  }
}
</script>
